export default {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  WARNING: 'warning',
  DANGER: 'danger',
  SUCCESS: 'success',
  INACTIVE: 'inactive',
  DEFAULT: 'default',
  INHERITED: 'inherited',
  LIGHT: 'light',
};
